import mux from "mux-embed";
import React, { useEffect, useRef } from "react";

export default function DykesHillsVid() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      const initTime = Date.now();
      mux.monitor(videoRef.current, {
        debug: true,
        data: {
          env_key: "ENV_KEY", // required
          // Metadata fields
          player_name: "Main Player", // any arbitrary string you want to use to identify this player
          player_init_time: initTime
          // ...
        }
      });
    }
  }, [videoRef]);

  return (
    <video
      controls
      ref={videoRef}
      src="https://firebasestorage.googleapis.com/v0/b/task-manager-58200.appspot.com/o/DroneVideo%2FDykesMovie.mp4?alt=media&token=f09e4264-6c64-4fa2-b653-02d24d685366"
      style={{ width: "100%"}}
    />
  );
}
